import Api from '@/services/Api'
import { authHeader } from '../helpers/auth-header'

export default {
  getUnits (params) {
    return Api().get(`admin/units/${params.company ? params.company + '/' : ''}`, { headers: authHeader() })
  }
}



// WEBPACK FOOTER //
// ./src/services/UnitService.js